// Small stroke-style action icons shared by icon-only Button instances across
// the app (table-row Edit/Unlink affordances). Centralized here after an audit
// found 13 separate inline re-implementations of the same pencil glyph with
// drifting sizes/path syntax — this is the single source of truth going
// forward, not a per-page local const.
export const EditSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
)

// The "+" glyph used by every list-page Create-flow CTA (matches the shape
// already used by the majority of these buttons — Assets/Systems/Data/Users/
// Offices/etc.). Added here for the 4 buttons that regressed to having no
// icon at all when the button-label audit removed the literal "+ " that used
// to be baked into their shared text key (common:buttons.addNew) — that
// leading "+" was never a real icon anywhere, so replacing the text lost it.
export const PlusSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
)

// A broken-link glyph for "Unlink" actions — deliberately distinct from the
// trash-can Delete icon (GapAnalysis/Show's "Unlink" action was previously
// borrowing Delete's own icon despite being a different, non-destructive
// action: it detaches an association, it doesn't remove the linked record).
export const UnlinkSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18.36 5.64a5 5 0 0 0-7.07 0l-1.94 1.93" />
    <path d="M5.64 18.36a5 5 0 0 0 7.07 0l1.94-1.93" />
    <path d="M8 12h.01" />
    <path d="M16 12h.01" />
    <line x1="2" y1="2" x2="22" y2="22" />
  </svg>
)
